import { useAuth } from "../../../../hooks/AuthContext";
import { Grid, Typography, Skeleton, Box } from "@mui/material";
import ButtonVoltar from "../../../../components/Botoes/ButtonVoltar";
import { ClienteEndereco } from "../../../../components";
import useStyles from "./styles";
import { Titulo } from "../../../../components";

const MeusEnderecos = ({ handlerCancelEdit }) => {
  const { user } = useAuth();
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Meus endereços
          </Titulo>
        </Grid>

        {/* Conteúdo principal */}
        <Grid item xs={12}>
          <ClienteEndereco idCliente={user.id} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MeusEnderecos;
